import { Ref, createContext, useCallback, useEffect, useRef, useState } from "react";
import { ApplicationContextType, LendingJobType, MonthlyReportSteps, StatementStepType, UnderwritingColdState, UnderwritingFormStatus, UnderwritingSteps, investorType, underwritingRoutes, uploadStates } from "../../../interfaces/interfaces";
import { RestS } from "../../../rest/rest-service";
import { GstRestS, type TallyAppConnectionStatus } from "../../../rest/gst-rest-service";
import moment from "moment";
import CircularLoader from "../../../components/common/CircularLoader/CircularLoader";
import styles from './UnderwritingContext.module.scss'
import { useNavigate } from "react-router";
import { getLocalUser } from "../../../components/functions/utilities";
import { v1 as uuidv1 } from "uuid";
import { getIn } from "final-form";
import { useAppDispatch, useAppSelector } from "../../../redux/reduxHooks";
import { removeVerifyGstJob, setRefreshGstJobs, setRefreshStatementJobs, setRefreshRevenueClassification } from "../../../redux/underwriting/underwriting";
// import { companyRows } from "../CompanyDetails/CompanyDetails";
import { companyRows } from "../CompanyDetails/companyDetailsHelper";
import { founderRows } from "../Director/directorHelper";
import { MonthlyReportFormContextType } from "../../MonthlyReport/context/MonthlyReportFormContext";
import _, { remove } from "lodash";
import { getLocalStorageDraft, clearLocalStorageDraft } from "../../../components/Hooks/useAutoSave";
import { useGstJobTracking } from "../../../components/Hooks/useGstJobTracking";


export type UnderwritingFormContextType = {
    formData: { [x: string]: any },
    formStepsValidity: { [x: string]: boolean },
    setFormData: (data: any) => void,
    brandCategoriesObj: { [x: string]: { id: number, category: string } },
    formRefs: React.MutableRefObject<{ [key: string]: any }>;
    setStepValidity: (step: any, isValid: boolean) => void;
    formCompleteStatus: { [x: string]: UnderwritingFormStatus };
    handleAndSetFormStatuses: (formStatuses: any) => void;
    uploadingPendingItems: any[];
    changeUploadStatus: (keyName: string, uploadStatus: uploadStates) => void;
    getUploadStatus: (keyName: string) => uploadStates;
    underwritingFileJobs: { [key in UnderwritingSteps | MonthlyReportSteps]: {
        [x: string]: any
    } };
    handleUnderwritingFileJobs: (step: UnderwritingSteps | MonthlyReportSteps, fieldName: string, jobDetails: any) => void;
    sendFileJobToApi: (step: UnderwritingSteps | MonthlyReportSteps, fieldName: string, jobDetails: any) => Promise<any>;
    statementAnalysisJobs: { [key: string]: any };
    fetchUnderwritingFileJobs: () => void;
    fetchStatementAnalysisJobs: () => void;
    revenueClassificationJobs: { [fyYear: string]: any };
    fetchRevenueClassificationJobs: (fyYear?: string) => void;
    clearRevenueClassificationJob: (fyYear: string) => void;
    clearAllRevenueClassificationData: (fyYear: string) => void;
    gstAnalysisJobs: { [key: string]: any };
    setGstAnalysisJobs: (jobs: any) => void;
    fetchGstAnalysisJobs: () => void;
    isTallyConnected: boolean;
    tallyLastSyncedAt: string | null;
    tallySynced: boolean;
    tallyConnection: TallyAppConnectionStatus | null;
    fetchTallyConnectionStatus: () => void;
    extraFormDetails?: any;
}

export const idProofInitialState = {
    type: '',
    file: null,
    uploadedFile: null,
}

export const founderIntialState = {
    founderDetail: {
        name: '',
        isDirector: false,
    },
    contactDetail: {
        phoneCode: "+91",
        phoneNumber: "",
    },
    linkedProfileLink: "",
    carrierHighlightsValue: ["", "", ""],
    // idProof: idProofInitialState
    ...founderRows.reduce((prev, curVal) => {
        prev[curVal.key] = {
            uploadedFile: null,
            selectedFile: null,
        };
        return prev;
    }, {})
}

export const gstDetailInitialState = {
    gstin: "",
    username: "",
    isVerified: false,
    jobId: null,
    gstCertificate: null,
    statementJobId: uuidv1(),
    credentialId: null as string | null,
}

export const investmentRoundsInitialState = {
    investmentDate: '',
    investorType: {
        label: 'Angel',
        value: investorType.angel
    },
    keyInvestors: '',
    investmentAmount: '',
}

export const investmentsInitialState = {
    raisedInvestment: 'yes',
    // investments: [
    //     investmentRoundsInitialState
    // ]
}

export const bankStatementFileInitialState = {
    type: '',
    file: null,
    uploadedFile: null,
}

export const shareholdersInitialState = {
    shareholdears: [{
        name: '',
        shares: 0,
        holding: 0,
    }],
    total: {
        shares: 0,
        holding: 0
    },
}

export const bankStatementsInitialState = {
    // accountName: "",
    // currentBalance: "",
    // statement: bankStatementFileInitialState
    statementType: StatementStepType.net_banking,
    statementJobId: uuidv1(),
    statements: [],
}

export const getInitialBankStatementDetails = () => {
    const newJobId = uuidv1();
    return {
        ...bankStatementsInitialState,
        statementJobId: newJobId,
    }
}

export const getInitialGstDetails = () => {
    const newJobId = uuidv1();
    return {
        ...gstDetailInitialState,
        statementJobId: newJobId,
    }
}

export const getLastThreeFinancialYears = () => {
    // const currentDate = new Date();
    // const currentYear = currentDate.getFullYear();
    // const startOfFinancialYear = new Date(currentYear, 31, 1); // April 1st

    // const today = moment();
    // const financialYears = [];
    // const currentYearFyStart = moment().month(3).date(30);
    // if (today.isAfter(currentYearFyStart)) {
    //     const startOfFy = moment().month(3).date(1);
    //     const endOfFy = moment().month(3).date(31).add(1, 'year');
    //     financialYears.push({
    //         fyStart: startOfFy.format("DD-MM-YYYY"),
    //         fyEnd: endOfFy.format("DD-MM-YYYY"),
    //         currentFullMonth: today.subtract(1, 'month').format("MM-YYYY"),
    //         // isAuditedFinancialRequired: today.isAfter(endOfFy.month(8).date(30)) ? true : false,
    //         isAuditedFinancialRequired: true,
    //         financialYear: `${startOfFy.format("YYYY")}-${endOfFy.format("YYYY")}`,
    //         fyPassed: false,
    //     })
    // } else {
    //     const startOfFy = moment().subtract(1, 'year').month(3).date(1);
    //     const endOfFy = moment().month(2).date(31);
    //     financialYears.push({
    //         fyStart: startOfFy.format("DD-MM-YYYY"),
    //         fyEnd: endOfFy.format("DD-MM-YYYY"),
    //         currentFullMonth: today.subtract(1, 'month').format("MM-YYYY"),
    //         // isAuditedFinancialRequired: today.isAfter(endOfFy.month(8).date(30)) ? true : false,
    //         isAuditedFinancialRequired: true,
    //         financialYear: `${startOfFy.format("YYYY")}-${endOfFy.format("YYYY")}`,
    //         fyPassed: today.isAfter(endOfFy) ? true : false,
    //     })
    // }

    // // **2nd & 3rd Financial Years (Previous FYs)**
    // for (let i = 0; i <= 1; i++) {
    //     const startOfFy = moment().month(3).date(1).subtract(i + 2, 'year'); // April 1st
    //     const endOfFy = moment().month(2).date(31).subtract(i + 1, 'year'); // March 31st

    //     financialYears.push({
    //         fyStart: startOfFy.format("DD-MM-YYYY"),
    //         fyEnd: endOfFy.format("DD-MM-YYYY"),
    //         currentFullMonth: today.clone().subtract(1, 'month').format("MM-YYYY"),
    //         isAuditedFinancialRequired: true, // Past years always need audit
    //         financialYear: `${startOfFy.format("YYYY")}-${endOfFy.format("YYYY")}`,
    //         fyPassed: true, // Past years are always completed
    //     });
    // }

    // // console.log('financialYears', financialYears)
    // return financialYears;

    // // if (today.month() > 4) {

    // // }

    // // const dummyArr = new Array(3).fill('')

    // // if (moment(new Date()).isAfter(moment(`31-03-${currentYear}`, "DD-MM-YYYY"), "date")) {
    // //     let startYear = currentYear;
    // //     let previousYear = startYear as any;
    // //     const allFinancialYears = [];
    // //     dummyArr.forEach((item, index) => {
    // //         previousYear = moment(startYear, "YYYY").subtract("1", "year").format("YYYY");
    // //         allFinancialYears.push(`${previousYear}-${startYear}`);
    // //         startYear = previousYear;
    // //     })
    // //     return allFinancialYears;
    // // } else {
    // //     let startYear = currentYear - 1;
    // //     let previousYear = startYear as any;
    // //     const allFinancialYears = [];
    // //     dummyArr.forEach((item, index) => {
    // //         previousYear = moment(startYear, "YYYY").subtract("1", "year").format("YYYY");
    // //         allFinancialYears.push(`${previousYear}-${startYear}`);
    // //         startYear = previousYear;
    // //     })
    // //     return allFinancialYears;
    // // }

    const today = moment().startOf('day');

    // If month >= 3 (April is 3 since months are 0-based), we’re in the FY that started this calendar year.
    // Else we’re in the FY that started last year.
    const fyStartYear = today.month() >= 3 ? today.year() : today.year() - 1;

    const financialYears = [];
    for (let k = 0; k < 3; k++) {
        const startOfFy = moment({ year: fyStartYear - k, month: 3, date: 1 });   // Apr 1
        const endOfFy = moment({ year: fyStartYear - k + 1, month: 2, date: 31 }); // Mar 31 next year

        const auditDeadline = moment({ year: fyStartYear - k + 1, month: 8, date: 30 }); // Sep 30 of end year
        financialYears.push({
            fyStart: startOfFy.format("DD-MM-YYYY"),
            fyEnd: endOfFy.format("DD-MM-YYYY"),
            currentFullMonth: today.clone().subtract(1, "month").format("MM-YYYY"), // do not mutate today
            isAuditedFinancialRequired: today.isAfter(auditDeadline, "day"),
            financialYear: `${startOfFy.format("YYYY")}-${endOfFy.format("YYYY")}`,
            fyPassed: today.isAfter(endOfFy, "day"),
        });
    }

    return financialYears;
}




export const UnderwritingFormContext = createContext<MonthlyReportFormContextType | UnderwritingFormContextType>(null);

const UnderWritingFormProvider = ({ children }) => {
    const [formData, setFormData] = useState({});
    const [brandCategoriesObj, setBrandCategoriesObj] = useState({});
    // const formStepsValidityRef = useRef({
    //     [UnderwritingSteps.accounts]: false,
    //     [UnderwritingSteps.company]: false,
    //     [UnderwritingSteps.revenue]: false,
    //     [UnderwritingSteps.keyEvents]: false,
    //     [UnderwritingSteps.investments]: false,
    //     [UnderwritingSteps.documents]: false,
    //     [UnderwritingSteps.pnl]: false,
    // });
    const [formStepsValidity, setFormStepsValidity] = useState({
        [UnderwritingSteps.accounts]: false,
        [UnderwritingSteps.revenue]: false,
        [UnderwritingSteps.keyEvents]: false,
        [UnderwritingSteps.company]: false,
        [UnderwritingSteps.investments]: false,
        [UnderwritingSteps.documents]: false,
        [UnderwritingSteps.pnl]: false,
    });

    const [formCompleteStatus, setFormCompleteStatus] = useState({
        [UnderwritingSteps.accounts]: UnderwritingFormStatus.INCOMPLETE,
        [UnderwritingSteps.revenue]: UnderwritingFormStatus.INCOMPLETE,
        [UnderwritingSteps.keyEvents]: UnderwritingFormStatus.INCOMPLETE,
        [UnderwritingSteps.company]: UnderwritingFormStatus.INCOMPLETE,
        [UnderwritingSteps.investments]: UnderwritingFormStatus.INCOMPLETE,
        [UnderwritingSteps.documents]: UnderwritingFormStatus.INCOMPLETE,
        [UnderwritingSteps.pnl]: UnderwritingFormStatus.INCOMPLETE,
    })
    const navigate = useNavigate();

    const [uploadingPendingItems, setUploadPendingItems] = useState<any[]>([]);
    const [fileUploadingStatus, setFileUploadingStatus] = useState({});

    const [underwritingFileJobs, setUnderwritingFileJobs] = useState<any>({
        [UnderwritingSteps.accounts]: {},
        [UnderwritingSteps.revenue]: {},
        [UnderwritingSteps.keyEvents]: {},
        [UnderwritingSteps.company]: {},
        [UnderwritingSteps.investments]: {},
        [UnderwritingSteps.documents]: {},
        [UnderwritingSteps.director]: {},
        [UnderwritingSteps.pnl]: {},
    });

    const [statementAnalysisJobs, setStatementAnalysisJobs] = useState({});
    const [revenueClassificationJobs, setRevenueClassificationJobs] = useState<{ [fyYear: string]: any }>({});
    const [isTallyConnected, setIsTallyConnected] = useState(false);
    const [tallyLastSyncedAt, setTallyLastSyncedAt] = useState<string | null>(null);
    const [tallySynced, setTallySynced] = useState(false);
    // Raw connection status, seeded into useTallyDashboardFlow's `initialConnection`
    // so the modal doesn't need its own checkStatus() round-trip on every open —
    // this page already fetches it once on mount.
    const [tallyConnection, setTallyConnection] = useState<TallyAppConnectionStatus | null>(null);

    const { gstAnalysisJobs, setGstAnalysisJobs, fetchGstAnalysisJobs } = useGstJobTracking();


    const underwritingFileJobsRef = useRef(underwritingFileJobs); // ✅ Ref to track latest state

    useEffect(() => {
        underwritingFileJobsRef.current = underwritingFileJobs; // ✅ Keep the ref in sync with state
    }, [underwritingFileJobs]);

    const [extraFormDetails, setExtraFormDetails] = useState<any>({});



    const handleUnderwritingFileJobs = (step: UnderwritingSteps | MonthlyReportSteps, fieldName: string, jobDetails: any) => {
        setUnderwritingFileJobs((prev) => ({
            ...prev,
            [step]: {
                ...prev[step],
                [fieldName]: jobDetails
            }
        }));
    }

    const handleFileJobUpdate = async (step: UnderwritingSteps, fieldName: string, jobDetails: any, sendToApi: boolean) => {
        // console.log('underwritingFileJobs', jobDetails)
        // const fileJob = getIn(underwritingFileJobs, `${step}.${fieldName}`);
        setUnderwritingFileJobs((prev) => ({
            ...prev,
            [step]: {
                ...prev[step],
                [fieldName]: {
                    ...prev[step][fieldName],
                    ...jobDetails
                }
            }
        }));
    }

    const sendFileJobToApi = async (step: UnderwritingSteps | MonthlyReportSteps, fieldName: string, jobDetails: any) => {
        try {
            const latestJobDetails = underwritingFileJobsRef.current[step]?.[fieldName];
            const updatedJobDetails = {
                ...latestJobDetails,
                ...jobDetails,
                step: step,
                formFieldName: fieldName,
            }
            console.log('updatedJobDetails', updatedJobDetails)
            const data: any = await RestS.sendUnderwritingUploadJob({
                jobDetails: updatedJobDetails,
                formId: extraFormDetails?.id,
                formType: ApplicationContextType.underwriting
            });

            setUnderwritingFileJobs((prev) => ({
                ...prev,
                [step]: {
                    ...prev[step],
                    [fieldName]: {
                        ...prev[step][fieldName],
                        ...data
                    }
                }
            }))
            return data
        } catch (error) {
            console.log('error', error)
        }
    }


    // console.log('fileUploadingStatus', fileUploadingStatus)



    const changeUploadStatus = (keyName: string, uploadStatus: uploadStates) => {
        setFileUploadingStatus((prev) => ({
            ...prev,
            [keyName]: uploadStatus
        }));
        if (uploadStatus == uploadStates.uploading) {
            setUploadPendingItems((prevUploads) => [...prevUploads, { uniqueKey: keyName, status: 'uploading' }]);
        } else {
            // oldPendingItems.delete(keyName as any);
            setUploadPendingItems((prevUploads) => prevUploads.filter(upload => upload.uniqueKey !== keyName));
        }
        // setUploadPendingItems(Array.from(oldPendingItems))
    }




    const getUploadStatus = (keyName: string) => {
        // console.log('keyName', keyName, fileUploadingStatus)
        // console.log('fileUploadingStatus', fileUploadingStatus[keyName])
        return fileUploadingStatus[keyName] ?? null;
    }

    const setStepValidity = useCallback((step: UnderwritingSteps, isValid: boolean) => {
        // console.log('changing step validity', step, "isValid", isValid)
        // formStepsValidityRef.current[step] = isValid;
        setFormStepsValidity({
            ...formStepsValidity,
            [step]: isValid
        })
    }, [formStepsValidity]);

    const { refreshStatementJobs, refreshGstJobs, verifyGstJobs, refreshRevenueClassification } = useAppSelector(state => state.underwriting)
    const dispatch = useAppDispatch();

    const formRefs = useRef({});
    const currentUser = getLocalUser();

    const handleInitialValues = (formValues = {}, websiteUrl: string) => {
        let initialValues = { ...formValues };
        initialValues = addInitalCompanyDetails(initialValues, websiteUrl);

        initialValues = handleInitialDirectorDetails(initialValues);

        initialValues = handleInitialRevenueDetails(initialValues);

        initialValues = addInitialInvestmentDetails(initialValues);

        initialValues = handleInitialUploadDocuments(initialValues);
        // console.log('initialValues', initialValues)
        setFormData({
            ...initialValues
        })
    }

    const [loading, setLoading] = useState(true);

    const handleInitialRevenueDetails = (values = {}) => {
        const fyYears = getLastThreeFinancialYears();
        console.log('fyYears', fyYears)
        const revenueDetails = values['revenueDetails'] ?? [];
        // return {
        //     ...values
        // }
        if (revenueDetails.length) {
            const revenueDetailsObj = values['revenueDetails'].reduce((prev, curVal) => {
                prev[curVal.financialYear] = curVal;
                return prev;
            }, {});
            // console.log('revenueDetailsObj', revenueDetailsObj)
            const formattedFyData = fyYears.reduce((prev, curVal) => {
                if (revenueDetailsObj[curVal?.financialYear] == undefined) {
                    prev.push({
                        financialYear: curVal?.financialYear,
                        financialYearDetails: curVal,
                        revenue: null,
                        auditedFinancials: [],
                        isAuditedFinancials: true, // we no longer require the provisional statement grid
                        provisionalStatement: null,
                    })
                } else {
                    prev.push({
                        ...revenueDetailsObj[curVal?.financialYear],
                        financialYearDetails: curVal,
                        isAuditedFinancials: true,
                    });
                }
                return prev;
            }, []);

            // console.log('formattedFyData', formattedFyData)
            return {
                ...values,
                revenueDetails: formattedFyData,
            }
        } else {
            const formattedFyData = fyYears.reduce((prev, curVal) => {
                prev.push({
                    financialYear: curVal?.financialYear,
                    financialYearDetails: curVal,
                    revenue: null,
                    auditedFinancials: [],
                    isAuditedFinancials: true,
                    provisionalStatement: null,
                })
                return prev;
            }, []);
            return {
                ...values,
                revenueDetails: formattedFyData
            }
        }
    }

    const handleInitialUploadDocuments = (values = {}) => {
        const bankStatements = values["bankStatements"] ?? [];
        if (bankStatements.length) {
            return {
                ...values,
                bankStatements: bankStatements
            }
        } else {
            return {
                ...values,
                bankStatements: [{
                    ...bankStatementsInitialState,
                    statementJobId: uuidv1(),
                }]
            }
        }
    }

    const addInitalCompanyDetails = (values: any = {}, websiteUrl: string) => {

        let allDocs = [];
        const initialCompanyDetails = {
            companyDoc: {},
            gstStatements: []
        }
        return {
            brandName: currentUser?.companyName,
            website: websiteUrl,
            ...initialCompanyDetails,
            ...values,
        }
    }

    const handleInitialDirectorDetails = (values = {}) => {
        const directorDetails = values["directors"] ?? [];
        if (directorDetails.length) {
            return {
                ...values
            }
        } else {
            return {
                directors: [
                    // founderIntialState
                    founderIntialState
                ],
                ...values,
            }
        }
    }


    const addInitialInvestmentDetails = (values = {}) => {
        const initialInvestmentDetails = {
            ...investmentsInitialState,
            ...values,
        }
        return initialInvestmentDetails;
    }

    // useEffect(() => {
    //     handleInitialValues();
    // }, [])

    const fetchBrandCategoryOptions = async () => {
        try {
            const { categories } = await RestS.fetchBrandCategoryOptions();
            if (categories.length) {
                const categoriesObj = categories.reduce((prev, curVal) => {
                    prev[curVal.id] = curVal;
                    return prev;
                }, {});
                setBrandCategoriesObj(categoriesObj);
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const handleAndSetFormStatuses = (formStatuses) => {
        const formStatusesObj = formStatuses.reduce((prev, curVal) => {
            prev[curVal.step] = curVal.status;
            return prev;
        }, {});
        setFormCompleteStatus(formStatusesObj);
    }

    const fetchFormData = async () => {
        try {
            const response: any = await RestS.fetchUnderwritingFormData();
            // console.log('formResponse', response);
            if (response?.success) {
                console.log('formResponse', response);

                const serverData = response.formData['data'] ?? {};
                const companyId = response.formData?.companyId?.toString() ?? "";
                const serverUpdatedAt = response.formData?.updated_at
                    ? new Date(response.formData.updated_at).getTime()
                    : 0;

                // Check localStorage for newer draft data
                const localDraft = getLocalStorageDraft(companyId);
                let formValues = serverData;

                if (localDraft && localDraft.timestamp > serverUpdatedAt) {
                    // localStorage has newer data - use it silently
                    formValues = localDraft.data;
                } else if (localDraft) {
                    // Server data is newer - clear stale localStorage
                    clearLocalStorageDraft(companyId);
                }

                handleInitialValues(formValues, response?.websiteUrl);
                const otherFormDetails = _.cloneDeep(response?.formData);
                delete otherFormDetails['data'];
                setExtraFormDetails({
                    ...otherFormDetails,
                    formType: LendingJobType.underwriting
                })
                handleAndSetFormStatuses(response?.formStatuses)
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const checkAndSetJourneyStatus = async () => {
        const { coldState, underwritingFormData, allowGetStarted, userDetails } = await RestS.checkUnderwritingJourney();
        if (coldState == UnderwritingColdState.accessDenied) {
            navigate('/404', {
                replace: true
            })
        } else if (coldState == UnderwritingColdState.pendingState) {
            navigate(underwritingRoutes.underwritingStatus, {
                replace: true,
            })
        }
    }

    const fetchStatementAnalysisJobs = async () => {
        try {
            // const bankStatementTaskIds = 
            const data: any = await RestS.fetchStatementAnalysisJob(ApplicationContextType.underwriting);
            console.log('statement analysis jobs', data);
            // if (data?.success) {
            if (data?.data?.length) {
                const allJobs = data.data;
                const allJobsObj = allJobs.reduce((prev, curVal) => {
                    if (!prev[curVal.taskId]) {
                        prev[curVal.taskId] = {
                            [curVal.jobType]: curVal
                        };
                    } else {
                        prev[curVal.taskId] = {
                            ...prev[curVal.taskId],
                            [curVal.jobType]: curVal
                        }
                    }
                    return prev;
                }, {});
                setStatementAnalysisJobs(allJobsObj);
            } else {
                setStatementAnalysisJobs({})
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const fetchTallyConnectionStatus = async () => {
        try {
            const res: any = await GstRestS.getJobStatus();
            const connection = res?.data?.tallyAppConnection;
            setIsTallyConnected(Boolean(connection?.tdlDownloaded && connection?.tallyConnected));
            setTallyLastSyncedAt(connection?.lastSyncedAt ?? null);
            setTallySynced(Boolean(connection?.tallySynced));
            setTallyConnection(connection ?? null);
        } catch (error) {
            console.log('error', error);
        }
    }

    const fetchRevenueClassificationJobs = async (fyYear?: string) => {
        try {
            if (fyYear) {
                const result = await RestS.fetchRevenueClassificationResult(fyYear) as any;
                console.log('revenue classification job for', fyYear, result);
                setRevenueClassificationJobs(prev => ({
                    ...prev,
                    [fyYear]: result?.data ?? null,
                }));
            } else {
                const fyYears = getLastThreeFinancialYears().map((fy) => fy.financialYear);
                const results = await Promise.all(
                    fyYears.map((fy) => RestS.fetchRevenueClassificationResult(fy) as Promise<any>)
                );
                const jobsByFyYear = fyYears.reduce((acc, fy, i) => {
                    acc[fy] = results[i]?.data ?? null;
                    return acc;
                }, {} as { [fyYear: string]: any });
                console.log('revenue classification jobs', jobsByFyYear);
                setRevenueClassificationJobs(jobsByFyYear);
            }
        } catch (error) {
            console.log('error fetching revenue classification jobs', error);
        }
    }

    const fetchUnderwritingFileJobs = async () => {
        try {
            const data: any = await RestS.fetchUploadedJobs(ApplicationContextType.underwriting);
            if (data?.data?.length) {
                const allJobs = data.data;
                const underwritingFileJobs = allJobs?.reduce((prev, curVal) => {
                    if (!prev[curVal.step]) {
                        prev[curVal.step] = {
                            [curVal.formFieldName]: curVal
                        }
                    } else {
                        prev[curVal.step] = {
                            ...prev[curVal.step],
                            [curVal.formFieldName]: curVal
                        }
                    }
                    return prev;
                }, {
                    [UnderwritingSteps.accounts]: {},
                    [UnderwritingSteps.revenue]: {},
                    [UnderwritingSteps.keyEvents]: {},
                    [UnderwritingSteps.company]: {},
                    [UnderwritingSteps.investments]: {},
                    [UnderwritingSteps.documents]: {},
                    [UnderwritingSteps.director]: {},
                    [UnderwritingSteps.pnl]: {},
                });
                console.log('underwritingFileJobs', underwritingFileJobs)
                setUnderwritingFileJobs(underwritingFileJobs);

            }
        } catch (error) {
            console.log('error', error)
        }
    }



    useEffect(() => {
        if (refreshStatementJobs) {
            fetchStatementAnalysisJobs();
            dispatch(setRefreshStatementJobs(false));
        }
    }, [refreshStatementJobs])

    useEffect(() => {
        if (refreshRevenueClassification) {
            fetchRevenueClassificationJobs(refreshRevenueClassification);
            dispatch(setRefreshRevenueClassification(null));
        }
    }, [refreshRevenueClassification])

    useEffect(() => {
        if (refreshGstJobs) {
            fetchGstAnalysisJobs();
            // fetchFormData();
            dispatch(setRefreshGstJobs(false));

        }
    }, [refreshGstJobs])



    useEffect(() => {
        // (() => {
        fetchBrandCategoryOptions();
        (async () => {
            try {
                // const data: any = await RestS.checkUnderwritingInvite();
                await Promise.all([
                    checkAndSetJourneyStatus(),
                    fetchFormData(),
                    fetchStatementAnalysisJobs(),
                    fetchUnderwritingFileJobs(),
                    fetchGstAnalysisJobs(),
                    fetchRevenueClassificationJobs(),
                    fetchTallyConnectionStatus(),
                ])
            } catch (error) {
                console.log('error', error)

            } finally {
                setLoading(false)
            }

        })();
        // })()
    }, [])

    const clearRevenueClassificationJob = (fyYear: string) => {
        setRevenueClassificationJobs(prev => ({
            ...prev,
            [fyYear]: {
                ...prev[fyYear],
                classificationErrorDetails: null,
            },
        }));
    };

    const clearAllRevenueClassificationData = (fyYear: string) => {
        setRevenueClassificationJobs(prev => {
            const next = { ...prev };
            delete next[fyYear];
            return next;
        });
    };

    return (
        <UnderwritingFormContext.Provider value={{ formData, setFormData, formStepsValidity, brandCategoriesObj, formRefs, setStepValidity, formCompleteStatus, handleAndSetFormStatuses, changeUploadStatus, uploadingPendingItems, getUploadStatus, underwritingFileJobs, handleUnderwritingFileJobs, sendFileJobToApi, statementAnalysisJobs, fetchUnderwritingFileJobs, fetchStatementAnalysisJobs, extraFormDetails, gstAnalysisJobs, setGstAnalysisJobs, fetchGstAnalysisJobs, revenueClassificationJobs, fetchRevenueClassificationJobs, clearRevenueClassificationJob, clearAllRevenueClassificationData, isTallyConnected, tallyLastSyncedAt, tallySynced, tallyConnection, fetchTallyConnectionStatus }}>
            {loading ?
                <div className={styles.loadingContainer}>
                    <CircularLoader />
                </div> :
                children}
        </UnderwritingFormContext.Provider>
    );
};

export default UnderWritingFormProvider;
